import script from "./OnboardingMaterialView.vue?vue&type=script&setup=true&lang=js"
export * from "./OnboardingMaterialView.vue?vue&type=script&setup=true&lang=js"

import "./OnboardingMaterialView.vue?vue&type=style&index=0&id=22607418&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22607418"]])

export default __exports__